<app-wait *ngIf="loadingBrand"></app-wait>

<ng-container *ngIf="!loadingBrand">
    <div class="not-found-left-side">
        <div [ngClass]="brandKey ? 'branded not-found' : 'not-found'">
            <div class="not-found-panel-header">
                <div class="not-found-header-title">
                    <ng-container *ngIf="brandKey"><img src="/images/sircon-logo-white.svg" alt="Sircon, a Vertafore company"> | </ng-container>Not Found
                </div>
            </div>

            <div class="not-found-info">
                <app-message-box [content]="errors"></app-message-box>
                <app-message-box level="caution" prominent="We're unable to locate your record">
                    <p>
                        If you recently onboarded with this carrier, please
                        allow some time to process your information.  Once
                        completed, you should be able to connect with the
                        carrier
                    </p>
                    If you have a Sircon account, you may
                        <button type="button" class="button-link" (click)="goToLogin()">sign in to your account</button>
                </app-message-box>
            </div>
        </div>
        <div class="walkup-help">
            <a *ngIf="carrierInformation" target="_blank" href="{{brandedWalkupHelpUrl()}}">Sircon Help & Support</a>
        </div>
    </div>
</ng-container>

<div *ngIf="brandKey" class="brand-panel">
    <app-brand-information (loadingBrandEvent)="loadingBrandEvent($event)"
                           (loadingErrorEvent)="loadingBrandErrorEvent()"
                           (carrierInformationEvent)="carrierInformationEvent($event)"
                           [messageOverride]="'Sircon helps you maintain insurance licensing and compliance easily by ' +
                            'giving you direct access to your carrier partners and the states you do business in, all in one place.'">
    </app-brand-information>
</div>
